import { Injector, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DependencyInjector } from './injector';
import { LocalizationModule } from '../localization/localization.module';
import { RoutingModule } from '../routing/routing.module';
import { HelperService } from './helpers/helper.service';
import { LoaderService } from './loading/loader.service';
import { CHASSIS_SUPPORT_PIPES } from './pipes/pipes';
import { CHASSIS_SUPPORT_DIRECTIVES } from './directives';
import { SessionService } from './sessions/session.service';
import { FormErrorComponent } from './form-errors/components/form-error/form-error.component';
import { LaddaModule } from 'angular2-ladda';
import { PopoverModule, TooltipModule } from 'ngx-bootstrap';
import { RenderComponent } from './render/components/render/render.component';
import { CurrencyPipe } from '../currency/pipes/currency.pipe';

@NgModule({
    imports: [
        CommonModule,
        LocalizationModule,
        RoutingModule,
        // AuthenticationModule,
        LaddaModule,
        TooltipModule.forRoot(),
        PopoverModule.forRoot()
    ],
    declarations: [
        CHASSIS_SUPPORT_PIPES,
        CHASSIS_SUPPORT_DIRECTIVES,
        FormErrorComponent,
        RenderComponent,
    ],
    exports: [
        CommonModule,
        LocalizationModule,
        RoutingModule,
        // AuthenticationModule,
        CHASSIS_SUPPORT_PIPES,
        CHASSIS_SUPPORT_DIRECTIVES,
        FormErrorComponent,
        LaddaModule,
        TooltipModule,
        PopoverModule,
        RenderComponent,
    ],
    providers: [
        HelperService,
        CurrencyPipe,
    ]
})
export class SupportModule {

    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SupportModule,
            providers: [LoaderService, SessionService]
        };
    }

    constructor(injector: Injector) {
        console.log('Dependency injector set');
        DependencyInjector.setInstance(injector);
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/support/support.module.ts